import CopyToClipboard from "../../Components/CopyToClipBoard";

const columns = [
    {
        field: "id",
        headerName: "Id",
        description: "id in the db",
        minWidth: 50,
        flex: 1,
    },
    {
        field: "name",
        headerName: "Name",
        minWidth: 50,
        flex: 1,
    },
    {
        field: "PartyType",
        headerName: "Type",
        minWidth: 50,
        flex: 1,
        valueGetter: (value) => {
            return value?.name;
        },
    },
    {
        field: "phone",
        headerName: "Phone",
        minWidth: 50,
        flex: 1,
        renderCell: (params) => {
            return <CopyToClipboard text={params.row.phone} />;
        },
    },
];
const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
/**
 * Function to get API URI
 * created for management of API URI changes
 */
const Get_URI = (method, data = {}) => {
    switch (method) {
        case "GET":
            return `${REACT_APP_BACKEND_URL}/otherparty/2?${data.queryParams}`;
        case "POST":
            return `${REACT_APP_BACKEND_URL}/items/create`;
        case "PATCH":
            return `${REACT_APP_BACKEND_URL}/items/${data.id}`;
        case "DELETE":
            return `${REACT_APP_BACKEND_URL}/items/${data.id}`;
        default:
            return "";
    }
};

export { columns, Get_URI };
